import { useState, useEffect } from 'react';

const MOBILE_BREAKPOINT = 768;

/**
 * Detects mobile devices via user-agent and viewport width.
 * Returns true if the device is likely a phone or small tablet.
 */
const useIsMobile = () => {
    const [isMobile, setIsMobile] = useState(() => {
        if (typeof window === 'undefined') return false;
        const ua = navigator.userAgent || '';
        const isMobileUA = /Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(ua);
        // iPad with desktop UA still has touch — but we allow tablets, so only flag phones
        return isMobileUA || window.innerWidth < MOBILE_BREAKPOINT;
    });

    useEffect(() => {
        const handleResize = () => {
            const ua = navigator.userAgent || '';
            const isMobileUA = /Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(ua);
            setIsMobile(isMobileUA || window.innerWidth < MOBILE_BREAKPOINT);
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return isMobile;
};

export default useIsMobile;
